import React, { useEffect, useState } from "react";
import { informationUsed } from "@/setting";
// import BuyerAgentAccordian from "./cif/BuyerAgentAccordian";
// import Buyer from "./cif/Buyer";
// import BuyersAgent from "./cif/BuyersAgent";
// import ProofOfFunds from "./cif/ProofOfFunds";
// import Submit from "./cif/Submit";
import {
  copyFilesFromTemplateToCif,
  getCifPageDetail,
  getUserProfile,
} from "@/api/bid";
import { cifFileUpload } from "@/api/placeOffer";
import { ShimmerContentBlock } from "react-shimmer-effects";
import EditBuyerAgentAccordion from "./editcif/EditBuyerAgentAccordian";
import EditBuyer from "./editcif/EditBuyer";
import EditBuyersAgent from "./editcif/EditBuyersAgent";
import EditProofOfFunds from "./editcif/EditProofOfFunds";
import EditSubmit from "./editcif/EditSubmit";
import { useSelector } from "react-redux";
import EditClosingAgentAndTitleInsuranceProvider from "./editcif/EditClosingAgentAndTitleInsuranceProvider";
import { useParams } from "react-router";
import { getCifDocuments } from "@/api/bid";

const INITIAL_ACCORDION_STATE = {
  accordion1: { close: false, disable: false, visited: true },
  accordion2: { close: true, disable: true, visited: false },
  accordion3: { close: true, disable: true, visited: false },
  accordion4: { close: true, disable: true, visited: false },
  accordion5: { close: true, disable: true, visited: false },
};

const EditCifDetails = ({
  offerDetails,
  cifId,
  setCifCompleted,
  cifData,
  paymentFlag,
  setIsBidDeposit,
  winningBidUserEmail,
}) => {
  let editCifUserData = cifData?.data;
  const {
    closingDetail,
    closingOptionDetails,
    listingId,
    propertyDetails,
    representedByAgent,
  } = editCifUserData;

  const { address, commonAttributes, imageDetails } = propertyDetails || {};

  const user = useSelector((state) => state?.user);

  // First Look (SPS 945): seller 945, Bank Owned (REO), non-CA state,
  // First Look flag "Y", and the current date is within the expiry window.
  const isFirstLookProp =
    propertyDetails?.sellerId === "945" &&
    propertyDetails?.commonAttributes?.propCategory === "REO" &&
    propertyDetails?.address?.state !== "CA" &&
    editCifUserData?.firstLook === "Y";

  // A saved CIF whose buyerCategory is a First Look category. When the First
  // Look window has already expired, we still show the two First Look options
  // (pre-populated) but read-only so the user can't change them.
  const hasSavedFirstLookCategory =
    editCifUserData?.buyer?.buyerCategory === "FL_OWNER_OCCUPIED_BUYER" ||
    editCifUserData?.buyer?.buyerCategory === "FL_QL_NON_PROFIT_CORP";

  // Show the First Look options when the window is active OR when editing a
  // CIF that was already saved as First Look (expired case, disabled).
  const showFirstLookOptions = isFirstLookProp || hasSavedFirstLookCategory;

  // When the window is expired but the CIF was saved as First Look, the two
  // options are shown pre-populated but read-only (user cannot change them).
  const firstLookReadOnly = hasSavedFirstLookCategory && !isFirstLookProp;

  const getPrimartEntityName = () => {
    if (showFirstLookOptions) {
      if (editCifUserData?.buyer?.buyerCategory === "FL_OWNER_OCCUPIED_BUYER") {
        return "firstLookOwnerOccupied";
      }
      if (editCifUserData?.buyer?.buyerCategory === "FL_QL_NON_PROFIT_CORP") {
        return "firstLookNonProfit";
      }
    }
    switch (editCifUserData?.buyer?.buyerCategory) {
      case "SELF_OCCUPANCY":
        return "selfOccupancy";

      case "HUD_APPROVED":
        return "hudNonProfit";

      case "GOVT_ENTITY":
        return "government";

      case "OWNER_OCCUPIED_BUYER":
        return "caBillOwnerOccupied";

      case "HUD_APPROVED":
        return "cwcotHudNonProfit";

      case "GOVT_ENTITY":
        return "cwcotGovernment";

      case "CA_OWNER_OCCUPIED_BUYER":
        return "caBillOwnerOccupied";

      case "NON_PROFIT_CORP":
        return "caBillNonProfit";

      case "COMMUNITY_LAND_TRUST":
        return "caBillLandTrust";

      case "LTD_EQUITY_HOUSING_CO":
        return "caBillHousingCoop";

      case "STATE_OF_CA":
        return "caBillCaliforniaState";

      default:
        const hasCompanyName = Boolean(
          editCifUserData?.buyer?.companyName &&
            editCifUserData?.buyer?.companyName.trim()
        );
        return hasCompanyName ? "business" : "individual";
    }
  };

  let isBuyingForSelf = "";
  let desc = "";
  if (cifData?.data?.agentFlag === "Y") {
    desc = "Agent";
    isBuyingForSelf = cifData?.data?.representedByAgent === "N" ? "Yes" : "No";
  } else {
    desc = "Buyer";
    isBuyingForSelf = cifData?.data?.representedByAgent === "Y" ? "Yes" : "No";
  }

  const hasCompanyName = Boolean(
    cifData?.data?.buyer?.companyName &&
      cifData?.data?.buyer?.companyName.trim()
  );
  let cobuyerEntity = "";
  if (cifData?.data?.coBuyer) {
    const hasCoCompanyName = Boolean(
      cifData?.data?.coBuyer?.companyName &&
        cifData?.data?.coBuyer?.companyName.trim()
    );
    cobuyerEntity = hasCoCompanyName ? "business" : "individual";
  } else {
    if (propertyDetails?.commonAttributes?.propCategory === "COMMERCIAL") {
      cobuyerEntity = "business";
    } else {
      cobuyerEntity = "individual";
    }
  }

  const [collapseAccordian, setCollapseAccordian] = useState(1);
  const [selectedDescription, setSelectedDescription] = useState(desc);
  const [buyingForSelf, setBuyingForSelf] = useState(isBuyingForSelf);
  const [submittedAccordions, setSubmittedAccordions] = useState([]);
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [commercialPof, setCommercialPof] = useState("");
  const [primaryEntityType, setPrimaryEntityType] = useState(
    getPrimartEntityName()
  );
  const [hasCobuyer, setHasCobuyer] = useState(
    cifData?.data.coBuyer !== null ? "yes" : "no"
  );
  const [cobuyerEntityType, setCobuyerEntityType] = useState(cobuyerEntity);
  const [mode, setMode] = useState("edit"); // 'list', 'new', 'edit'

  const [uploadedFiles, setUploadedFiles] = useState({
    primaryBuyer: [],
    pof: [],
    coBuyer: [],
    buyerSelfCWCOTFiles: [],
    buyerLLCFiles: [],
    caBillCommunityTrustlandFiles: [],
    caBillEquHousingCoFiles: [],
    caBillNonProfitCorpFiles: [],
    caBillOwnerOccupiedFiles: [],
    caBillStateofCalifornia: [],
    caBuyerCommunityTrustLandCWCOTFiles: [],
    caBuyerGovtCWCOTFiles: [],
    caBuyerLimEquHousingCooCWCOTFiles: [],
    caBuyerNonProfitCorpCWCOTFiles: [],
    caBuyerOwnerOccupiedCWCOTFiles: [],
    caBuyerStateOfClaiforniaCWCOTFiles: [],
  });

  const [formState, setFormState] = useState({
    cifFormDetails: {
      userRole: user?.user?.userType === "BUYR" ? "Buyer" : "Agent",
    },
    buyerAgent: false,
    pof: "",
    llc: "",
    profileDetails: null,
    accordionState: INITIAL_ACCORDION_STATE,
  });

  const getBuyerCat = () => {
    const category = editCifUserData?.buyer?.buyerCategory;

    switch (category) {
      case "GOVT_ENTITY":
        return { governmentEntityName: category };

      case "NON_PROFIT_CORP":
        return { caBillNonProfitName: category };

      case "COMMUNITY_LAND_TRUST":
        return { caBillLandTrustName: category };

      case "LTD_EQUITY_HOUSING_CO":
        return { caBillHousingCoopName: category };

      default:
        const hasCompanyName = Boolean(
          editCifUserData?.buyer?.companyName?.trim()
        );
        return hasCompanyName
          ? { business: category }
          : { individual: category };
    }
  };

  const [primaryBuyerData, setPrimaryBuyerData] = useState({
    firstName: editCifUserData?.buyer?.firstName,
    lastName: editCifUserData?.buyer?.lastName,
    middleInitials: editCifUserData?.buyer?.middleInitials,
    email: editCifUserData?.buyer?.email,
    phone: editCifUserData?.buyer?.phone,
    address1: editCifUserData?.buyer?.address1,
    address2: editCifUserData?.buyer?.address2,
    city: editCifUserData?.buyer?.city,
    stateId: editCifUserData?.buyer?.stateId,
    zip: editCifUserData?.buyer?.zip,
    companyName: editCifUserData?.buyer?.companyName,
    ...getBuyerCat(),
  });

  const [agentData, setAgentData] = useState({
    firstName: editCifUserData?.agent?.firstName || "",
    lastName: editCifUserData?.agent?.lastName || "",
    middleInitials: editCifUserData?.agent?.middleInitials || "",
    agencyName: editCifUserData?.agent?.companyName || "",
    email: editCifUserData?.agent?.email || "",
    phone: editCifUserData?.agent?.phone || "",
    address1: editCifUserData?.agent?.address1 || "",
    address2: editCifUserData?.agent?.address2 || "",
    city: editCifUserData?.agent?.city || "",
    stateId: editCifUserData?.agent?.stateId || "",
    zip: editCifUserData?.agent?.zip || "",
    corporateLicenseState: editCifUserData?.agent?.corpLicenceState || "",
    corporateLicenseNumber: editCifUserData?.agent?.corpLicenceNumber || "",
    individualLicenseState:
      cifData?.data?.propertyDetails?.address?.state || "",
    individualLicenseNumber: editCifUserData?.agent?.licenceNumber || "",
    licenseExpiryDate: editCifUserData?.agent?.licenceExpiryDate || "",
  });
  const [cobuyerData, setCobuyerData] = useState({
    firstName: editCifUserData?.coBuyer?.firstName,
    lastName: editCifUserData?.coBuyer?.lastName,
    middleInitials: editCifUserData?.coBuyer?.middleInitials,
    email: editCifUserData?.coBuyer?.email,
    phone: editCifUserData?.coBuyer?.phone,
    address1: editCifUserData?.coBuyer?.address1,
    address2: editCifUserData?.coBuyer?.address2,
    city: editCifUserData?.coBuyer?.city,
    stateId: editCifUserData?.coBuyer?.stateId,
    zip: editCifUserData?.coBuyer?.zip,
    companyName: editCifUserData?.coBuyer?.companyName,
  });

  const [closingAgentForm, setClosingAgentForm] = useState({
    name: "",
    email: "",
    company: "",
    phone: "",
    address1: "",
    address2: "",
    city: "",
    state: "",
    zip: "",
  });

  const [titleInsuranceForm, setTitleInsuranceForm] = useState({
    name: "",
    email: "",
    company: "",
    phone: "",
    address1: "",
    address2: "",
    city: "",
    state: "",
    zip: "",
  });
  const [selectedClosingOption, setSelectedClosingOption] = useState(
    cifData?.data?.closingDetail?.closingOption
  );

  const getPrimartEntity = () => {
    if (showFirstLookOptions) {
      if (editCifUserData?.buyer?.buyerCategory === "FL_OWNER_OCCUPIED_BUYER") {
        return "firstLookOwnerOccupied";
      }
      if (editCifUserData?.buyer?.buyerCategory === "FL_QL_NON_PROFIT_CORP") {
        return "firstLookNonProfit";
      }
    }
    switch (editCifUserData?.buyer?.buyerCategory) {
      case "SELF_OCCUPANCY":
        return "selfOccupancy";

      case "HUD_APPROVED":
        return "hudNonProfit";

      case "GOVT_ENTITY":
        return "government";

      case "OWNER_OCCUPIED_BUYER":
        return "caBillOwnerOccupied";

      case "HUD_APPROVED":
        return "cwcotHudNonProfit";

      case "GOVT_ENTITY":
        setPrimaryBuyerData((prev) => ({
          ...prev,
          governmentEntityName: editCifUserData.buyer.buyerCategoryName,
        }));
        return "cwcotGovernment";

      case "CA_OWNER_OCCUPIED_BUYER":
        return "caBillOwnerOccupied";

      case "NON_PROFIT_CORP":
        setPrimaryBuyerData((prev) => ({
          ...prev,
          caBillNonProfitName: editCifUserData.buyer.buyerCategoryName,
        }));
        return "caBillNonProfit";

      case "COMMUNITY_LAND_TRUST":
        setPrimaryBuyerData((prev) => ({
          ...prev,
          caBillLandTrustName: editCifUserData.buyer.buyerCategoryName,
        }));
        return "caBillLandTrust";

      case "LTD_EQUITY_HOUSING_CO":
        setPrimaryBuyerData((prev) => ({
          ...prev,
          caBillHousingCoopName: editCifUserData.buyer.buyerCategoryName,
        }));
        return "caBillHousingCoop";

      case "STATE_OF_CA":
        return "caBillCaliforniaState";

      default:
        const hasCompanyName = Boolean(
          editCifUserData?.buyer?.companyName &&
            editCifUserData?.buyer?.companyName.trim()
        );
        return hasCompanyName ? "business" : "individual";
    }
  };
  const { cifFormDetails, buyerAgent, pof, llc, profileDetails } = formState;

  const fetchUserProfile = async () => {
    try {
      const { status, data } = await getUserProfile();
      if (status === "SESSION_REQUIRED") {
        navigate("/");
        return;
      }
      setFormState((prev) => ({ ...prev, profileDetails: data }));
    } catch (error) {
      console.error("Error fetching user profile:", error);
    }
  };

  const fetchFileConfig = async () => {
    try {
      const { status, data } = await cifFileUpload({ listingId });
      if (status === "SUCCESS") {
        setFormState((prev) => ({
          ...prev,
          pof: data?.pofConfig,
          llc: data?.llcConfig,
        }));
        setCommercialPof(data?.isCommercialPreviewProperty);
      }
    } catch (error) {
      console.error("Error fetching file config:", error);
    }
  };

  useEffect(() => {
    if (listingId) {
      Promise.all([fetchUserProfile(), fetchFileConfig()]);
    }
  }, [listingId]);

  useEffect(() => {
    setFormState((prev) => ({
      ...prev,
      cifFormDetails: {
        ...prev.cifFormDetails,
        userRole: user.user.userType === "BUYR" ? "Buyer" : "Agent",
      },
    }));
  }, []);

  const updateCifFormDetails = (newDetails) => {
    setFormState((prev) => ({
      ...prev,
      cifFormDetails: { ...prev.cifFormDetails, ...newDetails },
    }));
  };

  const setBuyerAgentState = (value) => {
    setFormState((prev) => ({
      ...prev,
      buyerAgent: value,
    }));
  };
  useEffect(() => {
    // When component mounts, only first accordion should be open
    setCollapseAccordian(1);
    setSubmittedAccordions([]); // Start with no submitted accordions
  }, []);
  // console.log("cif data", cifData);
  // Add this to track which accordions should be visible/enabled

  const isAccordionEnabled = (accordionNumber) => {
    if (accordionNumber === 1) return true;

    // Special case for accordion 4
    if (accordionNumber === 4) {
      // If we're skipping accordion 3, check for accordion 2
      if (
        !(selectedDescription === "Buyer" && buyingForSelf === "Yes") &&
        !(selectedDescription === "Agent" && buyingForSelf === "No")
      ) {
        return submittedAccordions.includes(2);
      }
      // Otherwise, check for accordion 3
      return submittedAccordions.includes(3);
    }

    // Default case for other accordions
    return submittedAccordions.includes(accordionNumber - 1);
  };

  const getFilesArray = (fileArr) => {
    const filesData = fileArr?.map((item) => ({
      documentId: item?.documentId,
      fileName: item?.fileName,
      listingId: listingId || item.listingId,
    }));

    return filesData;
  };

  useEffect(() => {
    const prepopulateCifDocument = async () => {
      try {
        const response = await getCifDocuments(cifData?.data?.cifId); // Use imported JSON

        if (response?.data) {
          // Handle POF documents
          const pofFiles = response?.data?.data?.pofFiles;
          const buyerSelfCWCOTFiles = response?.data?.data?.buyerSelfCWCOTFiles;
          const buyerLLCFiles = response?.data?.data?.buyerLLCFiles;
          const caBillCommunityTrustlandFiles =
            response?.data?.data?.caBillCommunityTrustlandFiles;
          const caBillEquHousingCoFiles =
            response?.data?.data?.caBillEquHousingCoFiles;
          const caBillNonProfitCorpFiles =
            response?.data?.data?.caBillNonProfitCorpFiles;
          const caBillOwnerOccupiedFiles =
            response?.data?.data?.caBillOwnerOccupiedFiles;
          const caBillStateofCalifornia =
            response?.data?.data?.caBillStateofCalifornia;
          const caBuyerCommunityTrustLandCWCOTFiles =
            response?.data?.data?.caBuyerCommunityTrustLandCWCOTFiles;
          const caBuyerGovtCWCOTFiles =
            response?.data?.data?.caBuyerGovtCWCOTFiles;
          const caBuyerLimEquHousingCooCWCOTFiles =
            response?.data?.data?.caBuyerLimEquHousingCooCWCOTFiles;
          const caBuyerNonProfitCorpCWCOTFiles =
            response?.data?.data?.caBuyerNonProfitCorpCWCOTFiles;
          const caBuyerOwnerOccupiedCWCOTFiles =
            response?.data?.data?.caBuyerOwnerOccupiedCWCOTFiles;

          const caBuyerStateOfClaiforniaCWCOTFiles =
            response?.data?.data?.caBuyerStateOfClaiforniaCWCOTFiles;
          const coBuyerLLCFiles = response?.data?.data?.coBuyerLLCFiles;

          setUploadedFiles((prev) => ({
            ...prev,
            pof: getFilesArray(pofFiles),
            coBuyer: getFilesArray(coBuyerLLCFiles),
            buyerLLCFiles: getFilesArray(buyerLLCFiles),
            buyerSelfCWCOTFiles: getFilesArray(buyerSelfCWCOTFiles),
            caBillCommunityTrustlandFiles: getFilesArray(
              caBillCommunityTrustlandFiles
            ),
            caBillEquHousingCoFiles: getFilesArray(caBillEquHousingCoFiles),
            caBillNonProfitCorpFiles: getFilesArray(caBillNonProfitCorpFiles),
            caBillOwnerOccupiedFiles: getFilesArray(caBillOwnerOccupiedFiles),
            caBillStateofCalifornia: getFilesArray(caBillStateofCalifornia),
            caBuyerCommunityTrustLandCWCOTFiles: getFilesArray(
              caBuyerCommunityTrustLandCWCOTFiles
            ),
            caBuyerGovtCWCOTFiles: getFilesArray(caBuyerGovtCWCOTFiles),
            caBuyerLimEquHousingCooCWCOTFiles: getFilesArray(
              caBuyerLimEquHousingCooCWCOTFiles
            ),
            caBuyerNonProfitCorpCWCOTFiles: getFilesArray(
              caBuyerNonProfitCorpCWCOTFiles
            ),
            caBuyerOwnerOccupiedCWCOTFiles: getFilesArray(
              caBuyerOwnerOccupiedCWCOTFiles
            ),
            caBuyerStateOfClaiforniaCWCOTFiles: getFilesArray(
              caBuyerStateOfClaiforniaCWCOTFiles
            ),
          }));
        }
      } catch (error) {
        console.error("Error loading POF document:", error);
      }
    };

    // Only fetch POF document if we have listingId and jsonResponse
    if (cifData?.data?.cifId) {
      prepopulateCifDocument();
    } else {
      console.log("Conditions not met for POF document prepopulation");
    }
  }, [cifData?.data?.cifId]); // Dependencies

  useEffect(() => {
    // For second accordion (Buyer accordion)
    // if (
    //   (selectedDescription === "Buyer" && buyingForSelf === "No") ||
    //   (selectedDescription === "Buyer" && buyingForSelf === "Yes") ||
    //   (selectedDescription === "Agent" && buyingForSelf === "Yes")
    // ) {

    //   setPrimaryBuyerData({
    //     firstName: editCifUserData?.buyer?.firstName,
    //     lastName: editCifUserData?.buyer?.lastName,
    //     middleInitials: editCifUserData?.buyer?.middleInitials,
    //     email: editCifUserData?.buyer?.email,
    //     phone: editCifUserData?.buyer?.phone,
    //     address1: editCifUserData?.buyer?.address1,
    //     address2: editCifUserData?.buyer?.address2,
    //     city: editCifUserData?.buyer?.city,
    //     stateId: editCifUserData?.buyer?.stateId,
    //     zip: editCifUserData?.buyer?.zip,
    //     companyName: editCifUserData?.buyer?.companyName,
    //   });
    //   setPrimaryEntityType(getPrimartEntity());
    //   if (editCifUserData?.coBuyer) {
    //     setHasCobuyer("yes");
    //     setCobuyerData({
    //       firstName: editCifUserData?.coBuyer?.firstName,
    //       lastName: editCifUserData?.coBuyer?.lastName,
    //       middleInitials: editCifUserData?.coBuyer?.middleInitials,
    //       email: editCifUserData?.coBuyer?.email,
    //       phone: editCifUserData?.coBuyer?.phone,
    //       address1: editCifUserData?.coBuyer?.address1,
    //       address2: editCifUserData?.coBuyer?.address2,
    //       city: editCifUserData?.coBuyer?.city,
    //       stateId: editCifUserData?.coBuyer?.stateId,
    //       zip: editCifUserData?.coBuyer?.zip,
    //       companyName: editCifUserData?.coBuyer?.companyName,
    //     });
    //   }

    //   setAgentData({
    //     firstName: "",
    //     lastName: "",
    //     middleInitials: "",
    //     agencyName: "", // Added
    //     email: "",
    //     phone: "",
    //     address1: "",
    //     address2: "",
    //     city: "",
    //     stateId: "",
    //     zip: "",
    //     corporateLicenseState: "",
    //     corporateLicenseNumber: "",
    //     individualLicenseState: cifData?.data?.propertyDetails?.address?.state,
    //     individualLicenseNumber: "",
    //     licenseExpiryDate: "", // Added
    //   });
    // }

    // // For third accordion (Agent accordion)
    // if (cifData.data.agentFlag === 'N') {
    //   if (selectedDescription === "Agent" && buyingForSelf === "No") {
    //     // Prefill agent accordion with profile data
    //     // You would pass this data to EditBuyersAgent component
    //     setPrimaryBuyerData({
    //       firstName: "",
    //       lastName: "",
    //       middleInitials: "",
    //       email: "",
    //       phone: "",
    //       address1: "",
    //       address2: "",
    //       city: "",
    //       stateId: "",
    //       zip: "",
    //       companyName: "",
    //     });
    //     // setPrimaryEntityType("individual")
    //     if (editCifUserData?.coBuyer) {
    //       setHasCobuyer('no')
    //       setCobuyerData({
    //         firstName: "",
    //         lastName: "",
    //         middleInitials: "",
    //         email: "",
    //         phone: "",
    //         address1: "",
    //         address2: "",
    //         city: "",
    //         stateId: "",
    //         zip: "",
    //         companyName: "",
    //       });
    //     }

    //     setAgentData({
    //       firstName: editCifUserData?.buyer?.firstName,
    //       lastName: editCifUserData?.buyer?.lastName,
    //       middleInitials: editCifUserData?.buyer?.middleInitials,
    //       email: editCifUserData?.buyer?.email,
    //       phone: editCifUserData?.buyer?.phone,
    //       address1: editCifUserData?.buyer?.address1,
    //       address2: editCifUserData?.buyer?.address2,
    //       city: editCifUserData?.buyer?.city,
    //       stateId: editCifUserData?.buyer?.stateId,
    //       zip: editCifUserData?.buyer?.zip,
    //       corporateLicenseState: "",
    //       corporateLicenseNumber: "",
    //       individualLicenseState: cifData?.data?.propertyDetails?.address?.state,
    //       individualLicenseNumber: "",
    //     });
    //   }

    // }
    // if(cifData.data.agentFlag === 'Y'){
    //    if (selectedDescription === "Agent" && buyingForSelf === "No") {
    //     // Prefill agent accordion with profile data
    //     // You would pass this data to EditBuyersAgent component
    //     setPrimaryBuyerData({
    //       firstName: "",
    //       lastName: "",
    //       middleInitials: "",
    //       email: "",
    //       phone: "",
    //       address1: "",
    //       address2: "",
    //       city: "",
    //       stateId: "",
    //       zip: "",
    //       companyName: "",
    //     });
    //     // setPrimaryEntityType("individual")
    //     if (editCifUserData?.coBuyer) {
    //       setHasCobuyer('no')
    //       setCobuyerData({
    //         firstName: "",
    //         lastName: "",
    //         middleInitials: "",
    //         email: "",
    //         phone: "",
    //         address1: "",
    //         address2: "",
    //         city: "",
    //         stateId: "",
    //         zip: "",
    //         companyName: "",
    //       });
    //     }

    //     setAgentData({
    //       firstName: editCifUserData?.buyer?.firstName,
    //       lastName: editCifUserData?.buyer?.lastName,
    //       middleInitials: editCifUserData?.buyer?.middleInitials,
    //       email: editCifUserData?.buyer?.email,
    //       phone: editCifUserData?.buyer?.phone,
    //       address1: editCifUserData?.buyer?.address1,
    //       address2: editCifUserData?.buyer?.address2,
    //       city: editCifUserData?.buyer?.city,
    //       stateId: editCifUserData?.buyer?.stateId,
    //       zip: editCifUserData?.buyer?.zip,
    //       corporateLicenseState: "",
    //       corporateLicenseNumber: "",
    //       individualLicenseState: cifData?.data?.propertyDetails?.address?.state,
    //       individualLicenseNumber: "",
    //     });
    //   }
    // }

    // if (selectedDescription === "Buyer" && representedByAgent === 'Y') {
    //   setAgentData({
    //     firstName: editCifUserData?.agent?.firstName || "",
    //     lastName: editCifUserData?.agent?.lastName || "",
    //     middleInitials: editCifUserData?.agent?.middleInitials || "",
    //     agencyName: editCifUserData?.agent?.companyName || "",
    //     email: editCifUserData?.agent?.email || "",
    //     phone: editCifUserData?.agent?.phone || "",
    //     address1: editCifUserData?.agent?.address1 || "",
    //     address2: editCifUserData?.agent?.address2 || "",
    //     city: editCifUserData?.agent?.city || "",
    //     stateId: editCifUserData?.agent?.stateId || "",
    //     zip: editCifUserData?.agent?.zip || "",
    //     corporateLicenseState: editCifUserData?.agent?.corpLicenceState || "",
    //     corporateLicenseNumber: editCifUserData?.agent?.corpLicenceNumber || "",
    //     individualLicenseState: cifData?.data?.propertyDetails?.address?.state || "",
    //     individualLicenseNumber: editCifUserData?.agent?.licenceNumber || "",
    //     licenseExpiryDate: editCifUserData?.agent?.licenceExpiryDate || "",
    //   });
    // }

    // if (selectedDescription === "Agent" && buyingForSelf === "Yes" && representedByAgent === 'Y') {
    //   setPrimaryBuyerData({
    //     firstName: editCifUserData?.agent?.firstName,
    //     lastName: editCifUserData?.agent?.lastName,
    //     middleInitials: editCifUserData?.agent?.middleInitials,
    //     email: editCifUserData?.agent?.email,
    //     phone: editCifUserData?.agent?.phone,
    //     address1: editCifUserData?.agent?.address1,
    //     address2: editCifUserData?.agent?.address2,
    //     city: editCifUserData?.agent?.city,
    //     stateId: editCifUserData?.agent?.stateId,
    //     zip: editCifUserData?.agent?.zip,
    //     companyName: editCifUserData?.agent?.companyName,
    //   });
    //    setAgentData({
    //     firstName: "",
    //     lastName: "",
    //     middleInitials: "",
    //     agencyName: "", // Added
    //     email: "",
    //     phone: "",
    //     address1: "",
    //     address2: "",
    //     city: "",
    //     stateId: "",
    //     zip: "",
    //     corporateLicenseState: "",
    //     corporateLicenseNumber: "",
    //     individualLicenseState: cifData?.data?.propertyDetails?.address?.state,
    //     individualLicenseNumber: "",
    //     licenseExpiryDate: "", // Added
    //   });

    // }

    ///Agent Login
    if (
      cifData.data.agentFlag === "Y" &&
      cifData?.data?.buyerEmailId === null
    ) {
      if (selectedDescription === "Agent" && buyingForSelf === "No") {
        setPrimaryBuyerData({
          firstName: "",
          lastName: "",
          middleInitials: "",
          email: "",
          phone: "",
          address1: "",
          address2: "",
          city: "",
          stateId: "",
          zip: "",
          companyName: "",
        });
        setPrimaryEntityType(getPrimartEntity());
        if (editCifUserData?.coBuyer) {
          setHasCobuyer("no");
          setCobuyerData({
            firstName: "",
            lastName: "",
            middleInitials: "",
            email: "",
            phone: "",
            address1: "",
            address2: "",
            city: "",
            stateId: "",
            zip: "",
            companyName: "",
          });
        }
        setAgentData({
          firstName: editCifUserData?.buyer?.firstName,
          lastName: editCifUserData?.buyer?.lastName,
          middleInitials: editCifUserData?.buyer?.middleInitials,
          email: editCifUserData?.buyer?.email,
          phone: editCifUserData?.buyer?.phone,
          address1: editCifUserData?.buyer?.address1,
          address2: editCifUserData?.buyer?.address2,
          city: editCifUserData?.buyer?.city,
          stateId: editCifUserData?.buyer?.stateId,
          zip: editCifUserData?.buyer?.zip,
          corporateLicenseState: "",
          corporateLicenseNumber: "",
          individualLicenseState:
            cifData?.data?.propertyDetails?.address?.state,
          individualLicenseNumber: "",
          agencyName:formState?.profileDetails?.companyProfileDto?.brokerageName || ""
        });
      }
      if (selectedDescription === "Buyer" && buyingForSelf === "No") {
        setPrimaryBuyerData({
          firstName: editCifUserData?.buyer?.firstName,
          lastName: editCifUserData?.buyer?.lastName,
          middleInitials: editCifUserData?.buyer?.middleInitials,
          email: editCifUserData?.buyer?.email,
          phone: editCifUserData?.buyer?.phone,
          address1: editCifUserData?.buyer?.address1,
          address2: editCifUserData?.buyer?.address2,
          city: editCifUserData?.buyer?.city,
          stateId: editCifUserData?.buyer?.stateId,
          zip: editCifUserData?.buyer?.zip,
          companyName: editCifUserData?.buyer?.companyName,
        });
        setPrimaryEntityType(getPrimartEntity());

        if (editCifUserData?.coBuyer) {
          setHasCobuyer("yes");
          setCobuyerData({
            firstName: editCifUserData?.coBuyer?.firstName,
            lastName: editCifUserData?.coBuyer?.lastName,
            middleInitials: editCifUserData?.coBuyer?.middleInitials,
            email: editCifUserData?.coBuyer?.email,
            phone: editCifUserData?.coBuyer?.phone,
            address1: editCifUserData?.coBuyer?.address1,
            address2: editCifUserData?.coBuyer?.address2,
            city: editCifUserData?.coBuyer?.city,
            stateId: editCifUserData?.coBuyer?.stateId,
            zip: editCifUserData?.coBuyer?.zip,
            companyName: editCifUserData?.coBuyer?.companyName,
          });
        }
        setAgentData({
          firstName: "",
          lastName: "",
          middleInitials: "",
          agencyName: "", // Added
          email: "",
          phone: "",
          address1: "",
          address2: "",
          city: "",
          stateId: "",
          zip: "",
          corporateLicenseState: "",
          corporateLicenseNumber: "",
          individualLicenseState:
            cifData?.data?.propertyDetails?.address?.state,
          individualLicenseNumber: "",
          licenseExpiryDate: "", // Added
        });
      }
      if (selectedDescription === "Buyer" && buyingForSelf === "Yes") {
        setPrimaryBuyerData({
          firstName: editCifUserData?.buyer?.firstName,
          lastName: editCifUserData?.buyer?.lastName,
          middleInitials: editCifUserData?.buyer?.middleInitials,
          email: editCifUserData?.buyer?.email,
          phone: editCifUserData?.buyer?.phone,
          address1: editCifUserData?.buyer?.address1,
          address2: editCifUserData?.buyer?.address2,
          city: editCifUserData?.buyer?.city,
          stateId: editCifUserData?.buyer?.stateId,
          zip: editCifUserData?.buyer?.zip,
          companyName: editCifUserData?.buyer?.companyName,
        });
        setPrimaryEntityType(getPrimartEntity());

        if (editCifUserData?.coBuyer) {
          setHasCobuyer("yes");
          setCobuyerData({
            firstName: editCifUserData?.coBuyer?.firstName,
            lastName: editCifUserData?.coBuyer?.lastName,
            middleInitials: editCifUserData?.coBuyer?.middleInitials,
            email: editCifUserData?.coBuyer?.email,
            phone: editCifUserData?.coBuyer?.phone,
            address1: editCifUserData?.coBuyer?.address1,
            address2: editCifUserData?.coBuyer?.address2,
            city: editCifUserData?.coBuyer?.city,
            stateId: editCifUserData?.coBuyer?.stateId,
            zip: editCifUserData?.coBuyer?.zip,
            companyName: editCifUserData?.coBuyer?.companyName,
          });
        }
        setAgentData({
          firstName: "",
          lastName: "",
          middleInitials: "",
          agencyName: "", // Added
          email: "",
          phone: "",
          address1: "",
          address2: "",
          city: "",
          stateId: "",
          zip: "",
          corporateLicenseState: "",
          corporateLicenseNumber: "",
          individualLicenseState:
            cifData?.data?.propertyDetails?.address?.state,
          individualLicenseNumber: "",
          licenseExpiryDate: "", // Added
        });
      }
      if (selectedDescription === "Agent" && buyingForSelf === "Yes") {
        setPrimaryBuyerData({
          firstName: editCifUserData?.buyer?.firstName,
          lastName: editCifUserData?.buyer?.lastName,
          middleInitials: editCifUserData?.buyer?.middleInitials,
          email: editCifUserData?.buyer?.email,
          phone: editCifUserData?.buyer?.phone,
          address1: editCifUserData?.buyer?.address1,
          address2: editCifUserData?.buyer?.address2,
          city: editCifUserData?.buyer?.city,
          stateId: editCifUserData?.buyer?.stateId,
          zip: editCifUserData?.buyer?.zip,
          companyName: editCifUserData?.buyer?.companyName,
        });
        setPrimaryEntityType(getPrimartEntity());
        if (editCifUserData?.coBuyer) {
          setHasCobuyer("yes");
          setCobuyerData({
            firstName: editCifUserData?.coBuyer?.firstName,
            lastName: editCifUserData?.coBuyer?.lastName,
            middleInitials: editCifUserData?.coBuyer?.middleInitials,
            email: editCifUserData?.coBuyer?.email,
            phone: editCifUserData?.coBuyer?.phone,
            address1: editCifUserData?.coBuyer?.address1,
            address2: editCifUserData?.coBuyer?.address2,
            city: editCifUserData?.coBuyer?.city,
            stateId: editCifUserData?.coBuyer?.stateId,
            zip: editCifUserData?.coBuyer?.zip,
            companyName: editCifUserData?.coBuyer?.companyName,
          });
        }
        setAgentData({
          firstName: "",
          lastName: "",
          middleInitials: "",
          agencyName: "", // Added
          email: "",
          phone: "",
          address1: "",
          address2: "",
          city: "",
          stateId: "",
          zip: "",
          corporateLicenseState: "",
          corporateLicenseNumber: "",
          individualLicenseState:
            cifData?.data?.propertyDetails?.address?.state,
          individualLicenseNumber: "",
          licenseExpiryDate: "", // Added
        });
      }
    }
    if (
      cifData.data.agentFlag === "Y" &&
      cifData?.data?.buyerEmailId !== null
    ) {
      if (selectedDescription === "Agent" && buyingForSelf === "Yes") {
        setPrimaryBuyerData({
          firstName: editCifUserData?.agent?.firstName,
          lastName: editCifUserData?.agent?.lastName,
          middleInitials: editCifUserData?.agent?.middleInitials,
          email: editCifUserData?.agent?.email,
          phone: editCifUserData?.agent?.phone,
          address1: editCifUserData?.agent?.address1,
          address2: editCifUserData?.agent?.address2,
          city: editCifUserData?.agent?.city,
          stateId: editCifUserData?.agent?.stateId,
          zip: editCifUserData?.agent?.zip,
          companyName: editCifUserData?.agent?.companyName,
        });
        setPrimaryEntityType(getPrimartEntity());
        setAgentData({
          firstName: "",
          lastName: "",
          middleInitials: "",
          agencyName: "", // Added
          email: "",
          phone: "",
          address1: "",
          address2: "",
          city: "",
          stateId: "",
          zip: "",
          corporateLicenseState: "",
          corporateLicenseNumber: "",
          individualLicenseState:
            cifData?.data?.propertyDetails?.address?.state,
          individualLicenseNumber: "",
          licenseExpiryDate: "", // Added
        });
      }
      if (selectedDescription === "Buyer" && buyingForSelf === "No") {
        console.log("selectedDescription -> ", selectedDescription);
        console.log("buyingForSelf -> ", buyingForSelf);

        setPrimaryBuyerData({
          firstName: editCifUserData?.agent?.firstName,
          lastName: editCifUserData?.agent?.lastName,
          middleInitials: editCifUserData?.agent?.middleInitials,
          email: editCifUserData?.agent?.email,
          phone: editCifUserData?.agent?.phone,
          address1: editCifUserData?.agent?.address1,
          address2: editCifUserData?.agent?.address2,
          city: editCifUserData?.agent?.city,
          stateId: editCifUserData?.agent?.stateId,
          zip: editCifUserData?.agent?.zip,
          companyName: editCifUserData?.agent?.companyName,
        });
        setPrimaryEntityType(getPrimartEntity());

        setAgentData({
          firstName: "",
          lastName: "",
          middleInitials: "",
          agencyName: "", // Added
          email: "",
          phone: "",
          address1: "",
          address2: "",
          city: "",
          stateId: "",
          zip: "",
          corporateLicenseState: "",
          corporateLicenseNumber: "",
          individualLicenseState:
            cifData?.data?.propertyDetails?.address?.state,
          individualLicenseNumber: "",
          licenseExpiryDate: "", // Added
        });
      }
      if (selectedDescription === "Buyer" && buyingForSelf === "Yes") {
        setPrimaryBuyerData({
          firstName: editCifUserData?.agent?.firstName,
          lastName: editCifUserData?.agent?.lastName,
          middleInitials: editCifUserData?.agent?.middleInitials,
          email: editCifUserData?.agent?.email,
          phone: editCifUserData?.agent?.phone,
          address1: editCifUserData?.agent?.address1,
          address2: editCifUserData?.agent?.address2,
          city: editCifUserData?.agent?.city,
          stateId: editCifUserData?.agent?.stateId,
          zip: editCifUserData?.agent?.zip,
          companyName: editCifUserData?.agent?.companyName,
        });
        setPrimaryEntityType(getPrimartEntity());

        setAgentData({
          firstName: "",
          lastName: "",
          middleInitials: "",
          agencyName: "", // Added
          email: "",
          phone: "",
          address1: "",
          address2: "",
          city: "",
          stateId: "",
          zip: "",
          corporateLicenseState: "",
          corporateLicenseNumber: "",
          individualLicenseState:
            cifData?.data?.propertyDetails?.address?.state,
          individualLicenseNumber: "",
          licenseExpiryDate: "", // Added
        });

        // setPrimaryBuyerData({
        //   firstName: "",
        //   lastName: "",
        //   middleInitials: "",
        //   email: "",
        //   phone: "",
        //   address1: "",
        //   address2: "",
        //   city: "",
        //   stateId: "",
        //   zip: "",
        //   companyName: "",
        // });

        // setAgentData({
        //   firstName: editCifUserData?.agent?.firstName || "",
        //   lastName: editCifUserData?.agent?.lastName || "",
        //   middleInitials: editCifUserData?.agent?.middleInitials || "",
        //   agencyName: editCifUserData?.agent?.companyName || "",
        //   email: editCifUserData?.agent?.email || "",
        //   phone: editCifUserData?.agent?.phone || "",
        //   address1: editCifUserData?.agent?.address1 || "",
        //   address2: editCifUserData?.agent?.address2 || "",
        //   city: editCifUserData?.agent?.city || "",
        //   stateId: editCifUserData?.agent?.stateId || "",
        //   zip: editCifUserData?.agent?.zip || "",
        //   corporateLicenseState: editCifUserData?.agent?.corpLicenceState || "",
        //   corporateLicenseNumber: editCifUserData?.agent?.corpLicenceNumber || "",
        //   individualLicenseState: cifData?.data?.propertyDetails?.address?.state || "",
        //   individualLicenseNumber: editCifUserData?.agent?.licenceNumber || "",
        //   licenseExpiryDate: editCifUserData?.agent?.licenceExpiryDate || "",
        // });
      }
      if (selectedDescription === "Agent" && buyingForSelf === "No") {
        setPrimaryBuyerData({
          firstName: editCifUserData?.buyer?.firstName,
          lastName: editCifUserData?.buyer?.lastName,
          middleInitials: editCifUserData?.buyer?.middleInitials,
          email: editCifUserData?.buyer?.email,
          phone: editCifUserData?.buyer?.phone,
          address1: editCifUserData?.buyer?.address1,
          address2: editCifUserData?.buyer?.address2,
          city: editCifUserData?.buyer?.city,
          stateId: editCifUserData?.buyer?.stateId,
          zip: editCifUserData?.buyer?.zip,
          companyName: editCifUserData?.buyer?.companyName,
        });
        setPrimaryEntityType(getPrimartEntity());
        if (editCifUserData?.coBuyer) {
          setHasCobuyer("yes");
          setCobuyerData({
            firstName: editCifUserData?.coBuyer?.firstName,
            lastName: editCifUserData?.coBuyer?.lastName,
            middleInitials: editCifUserData?.coBuyer?.middleInitials,
            email: editCifUserData?.coBuyer?.email,
            phone: editCifUserData?.coBuyer?.phone,
            address1: editCifUserData?.coBuyer?.address1,
            address2: editCifUserData?.coBuyer?.address2,
            city: editCifUserData?.coBuyer?.city,
            stateId: editCifUserData?.coBuyer?.stateId,
            zip: editCifUserData?.coBuyer?.zip,
            companyName: editCifUserData?.coBuyer?.companyName,
          });
        }
        setAgentData({
          firstName: editCifUserData?.agent?.firstName || "",
          lastName: editCifUserData?.agent?.lastName || "",
          middleInitials: editCifUserData?.agent?.middleInitials || "",
          agencyName: editCifUserData?.agent?.companyName || formState?.profileDetails?.companyProfileDto?.brokerageName || "",
          email: editCifUserData?.agent?.email || "",
          phone: editCifUserData?.agent?.phone || "",
          address1: editCifUserData?.agent?.address1 || "",
          address2: editCifUserData?.agent?.address2 || "",
          city: editCifUserData?.agent?.city || "",
          stateId: editCifUserData?.agent?.stateId || "",
          zip: editCifUserData?.agent?.zip || "",
          corporateLicenseState: editCifUserData?.agent?.corpLicenceState || "",
          corporateLicenseNumber:
            editCifUserData?.agent?.corpLicenceNumber || "",
          individualLicenseState:
            cifData?.data?.propertyDetails?.address?.state || "",
          individualLicenseNumber: editCifUserData?.agent?.licenceNumber || "",
          licenseExpiryDate: editCifUserData?.agent?.licenceExpiryDate || "",
        });
      }
    }

    //Buyer Login
    // ///////////////////////////////////////////////////////////////////////////////////////////////////////////////
    if (cifData.data.agentFlag === "N" && representedByAgent === "Y") {
      if (selectedDescription === "Agent" && buyingForSelf === "No") {
        setPrimaryBuyerData({
          firstName: "",
          lastName: "",
          middleInitials: "",
          email: "",
          phone: "",
          address1: "",
          address2: "",
          city: "",
          stateId: "",
          zip: "",
          companyName: "",
        });
        setPrimaryEntityType(getPrimartEntity());
        if (editCifUserData?.coBuyer) {
          setHasCobuyer("no");
          setCobuyerData({
            firstName: "",
            lastName: "",
            middleInitials: "",
            email: "",
            phone: "",
            address1: "",
            address2: "",
            city: "",
            stateId: "",
            zip: "",
            companyName: "",
          });
        }

        setAgentData({
          firstName: editCifUserData?.buyer?.firstName,
          lastName: editCifUserData?.buyer?.lastName,
          middleInitials: editCifUserData?.buyer?.middleInitials,
          email: editCifUserData?.buyer?.email,
          phone: editCifUserData?.buyer?.phone,
          address1: editCifUserData?.buyer?.address1,
          address2: editCifUserData?.buyer?.address2,
          city: editCifUserData?.buyer?.city,
          stateId: editCifUserData?.buyer?.stateId,
          zip: editCifUserData?.buyer?.zip,
          corporateLicenseState: editCifUserData?.agent?.corpLicenceState || "",
          corporateLicenseNumber:
            editCifUserData?.agent?.corpLicenceNumber || "",
          individualLicenseState:
            cifData?.data?.propertyDetails?.address?.state || "",
          individualLicenseNumber: editCifUserData?.agent?.licenceNumber || "",
          licenseExpiryDate: editCifUserData?.agent?.licenceExpiryDate || "",
          agencyName:formState?.profileDetails?.companyProfileDto?.brokerageName || ""
        });
        //     setAgentData({
        //   firstName: editCifUserData?.agent?.firstName || "",
        //   lastName: editCifUserData?.agent?.lastName || "",
        //   middleInitials: editCifUserData?.agent?.middleInitials || "",
        //   agencyName: editCifUserData?.agent?.companyName || "",
        //   email: editCifUserData?.agent?.email || "",
        //   phone: editCifUserData?.agent?.phone || "",
        //   address1: editCifUserData?.agent?.address1 || "",
        //   address2: editCifUserData?.agent?.address2 || "",
        //   city: editCifUserData?.agent?.city || "",
        //   stateId: editCifUserData?.agent?.stateId || "",
        //   zip: editCifUserData?.agent?.zip || "",
        //   corporateLicenseState: editCifUserData?.agent?.corpLicenceState || "",
        //   corporateLicenseNumber: editCifUserData?.agent?.corpLicenceNumber || "",
        //   individualLicenseState: cifData?.data?.propertyDetails?.address?.state || "",
        //   individualLicenseNumber: editCifUserData?.agent?.licenceNumber || "",
        //   licenseExpiryDate: editCifUserData?.agent?.licenceExpiryDate || "",
        // });
      }
      if (selectedDescription === "Buyer" && buyingForSelf === "No") {
        setPrimaryBuyerData({
          firstName: editCifUserData?.buyer?.firstName,
          lastName: editCifUserData?.buyer?.lastName,
          middleInitials: editCifUserData?.buyer?.middleInitials,
          email: editCifUserData?.buyer?.email,
          phone: editCifUserData?.buyer?.phone,
          address1: editCifUserData?.buyer?.address1,
          address2: editCifUserData?.buyer?.address2,
          city: editCifUserData?.buyer?.city,
          stateId: editCifUserData?.buyer?.stateId,
          zip: editCifUserData?.buyer?.zip,
          companyName: editCifUserData?.buyer?.companyName,
        });
        setPrimaryEntityType(getPrimartEntity());

        if (editCifUserData?.coBuyer) {
          setHasCobuyer("yes");
          setCobuyerData({
            firstName: editCifUserData?.coBuyer?.firstName,
            lastName: editCifUserData?.coBuyer?.lastName,
            middleInitials: editCifUserData?.coBuyer?.middleInitials,
            email: editCifUserData?.coBuyer?.email,
            phone: editCifUserData?.coBuyer?.phone,
            address1: editCifUserData?.coBuyer?.address1,
            address2: editCifUserData?.coBuyer?.address2,
            city: editCifUserData?.coBuyer?.city,
            stateId: editCifUserData?.coBuyer?.stateId,
            zip: editCifUserData?.coBuyer?.zip,
            companyName: editCifUserData?.coBuyer?.companyName,
          });
        }
        setAgentData({
          firstName: "",
          lastName: "",
          middleInitials: "",
          agencyName: "", // Added
          email: "",
          phone: "",
          address1: "",
          address2: "",
          city: "",
          stateId: "",
          zip: "",
          corporateLicenseState: "",
          corporateLicenseNumber: "",
          individualLicenseState:
            cifData?.data?.propertyDetails?.address?.state,
          individualLicenseNumber: "",
          licenseExpiryDate: "", // Added
        });
      }
      if (selectedDescription === "Agent" && buyingForSelf === "Yes") {
        setPrimaryBuyerData({
          firstName: editCifUserData?.buyer?.firstName,
          lastName: editCifUserData?.buyer?.lastName,
          middleInitials: editCifUserData?.buyer?.middleInitials,
          email: editCifUserData?.buyer?.email,
          phone: editCifUserData?.buyer?.phone,
          address1: editCifUserData?.buyer?.address1,
          address2: editCifUserData?.buyer?.address2,
          city: editCifUserData?.buyer?.city,
          stateId: editCifUserData?.buyer?.stateId,
          zip: editCifUserData?.buyer?.zip,
          companyName: editCifUserData?.buyer?.companyName,
        });
        setPrimaryEntityType(getPrimartEntity());

        if (editCifUserData?.coBuyer) {
          setHasCobuyer("yes");
          setCobuyerData({
            firstName: editCifUserData?.coBuyer?.firstName,
            lastName: editCifUserData?.coBuyer?.lastName,
            middleInitials: editCifUserData?.coBuyer?.middleInitials,
            email: editCifUserData?.coBuyer?.email,
            phone: editCifUserData?.coBuyer?.phone,
            address1: editCifUserData?.coBuyer?.address1,
            address2: editCifUserData?.coBuyer?.address2,
            city: editCifUserData?.coBuyer?.city,
            stateId: editCifUserData?.coBuyer?.stateId,
            zip: editCifUserData?.coBuyer?.zip,
            companyName: editCifUserData?.coBuyer?.companyName,
          });
        }
        setAgentData({
          firstName: "",
          lastName: "",
          middleInitials: "",
          agencyName: "", // Added
          email: "",
          phone: "",
          address1: "",
          address2: "",
          city: "",
          stateId: "",
          zip: "",
          corporateLicenseState: "",
          corporateLicenseNumber: "",
          individualLicenseState:
            cifData?.data?.propertyDetails?.address?.state,
          individualLicenseNumber: "",
          licenseExpiryDate: "", // Added
        });
      }
      if (selectedDescription === "Buyer" && buyingForSelf === "Yes") {
        //Represented By Agent
        setPrimaryBuyerData({
          firstName: editCifUserData?.buyer?.firstName,
          lastName: editCifUserData?.buyer?.lastName,
          middleInitials: editCifUserData?.buyer?.middleInitials,
          email: editCifUserData?.buyer?.email,
          phone: editCifUserData?.buyer?.phone,
          address1: editCifUserData?.buyer?.address1,
          address2: editCifUserData?.buyer?.address2,
          city: editCifUserData?.buyer?.city,
          stateId: editCifUserData?.buyer?.stateId,
          zip: editCifUserData?.buyer?.zip,
          companyName: editCifUserData?.buyer?.companyName,
        });
        setPrimaryEntityType(getPrimartEntity());

        if (editCifUserData?.coBuyer) {
          setHasCobuyer("yes");
          setCobuyerData({
            firstName: editCifUserData?.coBuyer?.firstName,
            lastName: editCifUserData?.coBuyer?.lastName,
            middleInitials: editCifUserData?.coBuyer?.middleInitials,
            email: editCifUserData?.coBuyer?.email,
            phone: editCifUserData?.coBuyer?.phone,
            address1: editCifUserData?.coBuyer?.address1,
            address2: editCifUserData?.coBuyer?.address2,
            city: editCifUserData?.coBuyer?.city,
            stateId: editCifUserData?.coBuyer?.stateId,
            zip: editCifUserData?.coBuyer?.zip,
            companyName: editCifUserData?.coBuyer?.companyName,
          });
        }
        setAgentData({
          firstName: editCifUserData?.agent?.firstName || "",
          lastName: editCifUserData?.agent?.lastName || "",
          middleInitials: editCifUserData?.agent?.middleInitials || "",
          agencyName: editCifUserData?.agent?.companyName || "",
          email: editCifUserData?.agent?.email || "",
          phone: editCifUserData?.agent?.phone || "",
          address1: editCifUserData?.agent?.address1 || "",
          address2: editCifUserData?.agent?.address2 || "",
          city: editCifUserData?.agent?.city || "",
          stateId: editCifUserData?.agent?.stateId || "",
          zip: editCifUserData?.agent?.zip || "",
          corporateLicenseState: editCifUserData?.agent?.corpLicenceState || "",
          corporateLicenseNumber:
            editCifUserData?.agent?.corpLicenceNumber || "",
          individualLicenseState:
            cifData?.data?.propertyDetails?.address?.state || "",
          individualLicenseNumber: editCifUserData?.agent?.licenceNumber || "",
          licenseExpiryDate: editCifUserData?.agent?.licenceExpiryDate || "",
        });
      }
    }
    if (cifData.data.agentFlag === "N" && representedByAgent === "N") {
      if (selectedDescription === "Agent" && buyingForSelf === "No") {
        setPrimaryBuyerData({
          firstName: "",
          lastName: "",
          middleInitials: "",
          email: "",
          phone: "",
          address1: "",
          address2: "",
          city: "",
          stateId: "",
          zip: "",
          companyName: "",
        });
        // setPrimaryEntityType("individual")
        if (editCifUserData?.coBuyer) {
          setHasCobuyer("no");
          setCobuyerData({
            firstName: "",
            lastName: "",
            middleInitials: "",
            email: "",
            phone: "",
            address1: "",
            address2: "",
            city: "",
            stateId: "",
            zip: "",
            companyName: "",
          });
        }
        setAgentData({
          firstName: editCifUserData?.buyer?.firstName,
          lastName: editCifUserData?.buyer?.lastName,
          middleInitials: editCifUserData?.buyer?.middleInitials,
          email: editCifUserData?.buyer?.email,
          phone: editCifUserData?.buyer?.phone,
          address1: editCifUserData?.buyer?.address1,
          address2: editCifUserData?.buyer?.address2,
          city: editCifUserData?.buyer?.city,
          stateId: editCifUserData?.buyer?.stateId,
          zip: editCifUserData?.buyer?.zip,
          corporateLicenseState: editCifUserData?.agent?.corpLicenceState || "",
          corporateLicenseNumber:
            editCifUserData?.agent?.corpLicenceNumber || "",
          individualLicenseState:
            cifData?.data?.propertyDetails?.address?.state || "",
          individualLicenseNumber: editCifUserData?.agent?.licenceNumber || "",
          licenseExpiryDate: editCifUserData?.agent?.licenceExpiryDate || "",
          agencyName:formState?.profileDetails?.companyProfileDto?.brokerageName || ""
        });
      }
      if (selectedDescription === "Buyer" && buyingForSelf === "No") {
        setPrimaryBuyerData({
          firstName: editCifUserData?.buyer?.firstName,
          lastName: editCifUserData?.buyer?.lastName,
          middleInitials: editCifUserData?.buyer?.middleInitials,
          email: editCifUserData?.buyer?.email,
          phone: editCifUserData?.buyer?.phone,
          address1: editCifUserData?.buyer?.address1,
          address2: editCifUserData?.buyer?.address2,
          city: editCifUserData?.buyer?.city,
          stateId: editCifUserData?.buyer?.stateId,
          zip: editCifUserData?.buyer?.zip,
          companyName: editCifUserData?.buyer?.companyName,
        });
        setPrimaryEntityType(getPrimartEntity());

        if (editCifUserData?.coBuyer) {
          setHasCobuyer("yes");
          setCobuyerData({
            firstName: editCifUserData?.coBuyer?.firstName,
            lastName: editCifUserData?.coBuyer?.lastName,
            middleInitials: editCifUserData?.coBuyer?.middleInitials,
            email: editCifUserData?.coBuyer?.email,
            phone: editCifUserData?.coBuyer?.phone,
            address1: editCifUserData?.coBuyer?.address1,
            address2: editCifUserData?.coBuyer?.address2,
            city: editCifUserData?.coBuyer?.city,
            stateId: editCifUserData?.coBuyer?.stateId,
            zip: editCifUserData?.coBuyer?.zip,
            companyName: editCifUserData?.coBuyer?.companyName,
          });
        }
        setAgentData({
          firstName: "",
          lastName: "",
          middleInitials: "",
          agencyName: "", // Added
          email: "",
          phone: "",
          address1: "",
          address2: "",
          city: "",
          stateId: "",
          zip: "",
          corporateLicenseState: "",
          corporateLicenseNumber: "",
          individualLicenseState:
            cifData?.data?.propertyDetails?.address?.state,
          individualLicenseNumber: "",
          licenseExpiryDate: "", // Added
        });
      }
      if (selectedDescription === "Agent" && buyingForSelf === "Yes") {
        setPrimaryBuyerData({
          firstName: editCifUserData?.buyer?.firstName,
          lastName: editCifUserData?.buyer?.lastName,
          middleInitials: editCifUserData?.buyer?.middleInitials,
          email: editCifUserData?.buyer?.email,
          phone: editCifUserData?.buyer?.phone,
          address1: editCifUserData?.buyer?.address1,
          address2: editCifUserData?.buyer?.address2,
          city: editCifUserData?.buyer?.city,
          stateId: editCifUserData?.buyer?.stateId,
          zip: editCifUserData?.buyer?.zip,
          companyName: editCifUserData?.buyer?.companyName,
        });
        setPrimaryEntityType(getPrimartEntity());

        if (editCifUserData?.coBuyer) {
          setHasCobuyer("yes");
          setCobuyerData({
            firstName: editCifUserData?.coBuyer?.firstName,
            lastName: editCifUserData?.coBuyer?.lastName,
            middleInitials: editCifUserData?.coBuyer?.middleInitials,
            email: editCifUserData?.coBuyer?.email,
            phone: editCifUserData?.coBuyer?.phone,
            address1: editCifUserData?.coBuyer?.address1,
            address2: editCifUserData?.coBuyer?.address2,
            city: editCifUserData?.coBuyer?.city,
            stateId: editCifUserData?.coBuyer?.stateId,
            zip: editCifUserData?.coBuyer?.zip,
            companyName: editCifUserData?.coBuyer?.companyName,
          });
        }
        setAgentData({
          firstName: "",
          lastName: "",
          middleInitials: "",
          agencyName: "", // Added
          email: "",
          phone: "",
          address1: "",
          address2: "",
          city: "",
          stateId: "",
          zip: "",
          corporateLicenseState: "",
          corporateLicenseNumber: "",
          individualLicenseState:
            cifData?.data?.propertyDetails?.address?.state,
          individualLicenseNumber: "",
          licenseExpiryDate: "", // Added
        });
      }
      if (selectedDescription === "Buyer" && buyingForSelf === "Yes") {
        //Represented By Agent
        setPrimaryBuyerData({
          firstName: editCifUserData?.buyer?.firstName,
          lastName: editCifUserData?.buyer?.lastName,
          middleInitials: editCifUserData?.buyer?.middleInitials,
          email: editCifUserData?.buyer?.email,
          phone: editCifUserData?.buyer?.phone,
          address1: editCifUserData?.buyer?.address1,
          address2: editCifUserData?.buyer?.address2,
          city: editCifUserData?.buyer?.city,
          stateId: editCifUserData?.buyer?.stateId,
          zip: editCifUserData?.buyer?.zip,
          companyName: editCifUserData?.buyer?.companyName,
        });
        setPrimaryEntityType(getPrimartEntity());

        if (editCifUserData?.coBuyer) {
          setHasCobuyer("yes");
          setCobuyerData({
            firstName: editCifUserData?.coBuyer?.firstName,
            lastName: editCifUserData?.coBuyer?.lastName,
            middleInitials: editCifUserData?.coBuyer?.middleInitials,
            email: editCifUserData?.coBuyer?.email,
            phone: editCifUserData?.coBuyer?.phone,
            address1: editCifUserData?.coBuyer?.address1,
            address2: editCifUserData?.coBuyer?.address2,
            city: editCifUserData?.coBuyer?.city,
            stateId: editCifUserData?.coBuyer?.stateId,
            zip: editCifUserData?.coBuyer?.zip,
            companyName: editCifUserData?.coBuyer?.companyName,
          });
        }
        setAgentData({
          firstName: editCifUserData?.agent?.firstName || "",
          lastName: editCifUserData?.agent?.lastName || "",
          middleInitials: editCifUserData?.agent?.middleInitials || "",
          agencyName: editCifUserData?.agent?.companyName || "",
          email: editCifUserData?.agent?.email || "",
          phone: editCifUserData?.agent?.phone || "",
          address1: editCifUserData?.agent?.address1 || "",
          address2: editCifUserData?.agent?.address2 || "",
          city: editCifUserData?.agent?.city || "",
          stateId: editCifUserData?.agent?.stateId || "",
          zip: editCifUserData?.agent?.zip || "",
          corporateLicenseState: editCifUserData?.agent?.corpLicenceState || "",
          corporateLicenseNumber:
            editCifUserData?.agent?.corpLicenceNumber || "",
          individualLicenseState:
            cifData?.data?.propertyDetails?.address?.state || "",
          individualLicenseNumber: editCifUserData?.agent?.licenceNumber || "",
          licenseExpiryDate: editCifUserData?.agent?.licenceExpiryDate || "",
        });
      }
    }
  }, [selectedDescription, buyingForSelf]);

  return (
    <div className="">
      <div className="cif-data-body">
        <div className="accordion accordion-flush" id="accordionFlushExample">
          {/* //!THIS IS THE FIRST ACCORDIAN */}
          <EditBuyerAgentAccordion
            user={user}
            setCollapseAccordian={setCollapseAccordian}
            collapseAccordian={collapseAccordian}
            selectedDescription={selectedDescription}
            buyingForSelf={buyingForSelf}
            setBuyingForSelf={setBuyingForSelf}
            setSelectedDescription={setSelectedDescription}
            cifData={cifData}
            submittedAccordions={submittedAccordions}
            setSubmittedAccordions={setSubmittedAccordions}
            isEnabled={isAccordionEnabled(1)}
          />
          {/* //!THIS IS THE SECOND ACCORDIAN */}
          <EditBuyer
            setCollapseAccordian={setCollapseAccordian}
            collapseAccordian={collapseAccordian}
            selectedDescription={selectedDescription}
            buyingForSelf={buyingForSelf}
            submittedAccordions={submittedAccordions}
            setSubmittedAccordions={setSubmittedAccordions}
            cifData={cifData}
            isEnabled={isAccordionEnabled(2)}
            primaryBuyerData={primaryBuyerData}
            setPrimaryBuyerData={setPrimaryBuyerData}
            setCobuyerData={setCobuyerData}
            cobuyerData={cobuyerData}
            listingId={listingId}
            mode={"edit"}
            agentData={agentData}
            primaryEntityType={primaryEntityType}
            setPrimaryEntityType={setPrimaryEntityType}
            hasCobuyer={hasCobuyer}
            setHasCobuyer={setHasCobuyer}
            cobuyerEntityType={cobuyerEntityType}
            setCobuyerEntityType={setCobuyerEntityType}
            uploadedFiles={uploadedFiles}
            setUploadedFiles={setUploadedFiles}
            isSubmitting={isSubmitting}
            setIsSubmitting={setIsSubmitting}
            formState={formState}
            showFirstLookOptions={showFirstLookOptions}
            firstLookReadOnly={firstLookReadOnly}
          />
          {/* //!THIS IS THE THIRD ACCORDIAN */}
          {((selectedDescription === "Buyer" && buyingForSelf === "Yes") ||
            (selectedDescription === "Agent" && buyingForSelf === "No")) && (
            <EditBuyersAgent
              setCollapseAccordian={setCollapseAccordian}
              collapseAccordian={collapseAccordian}
              cifData={cifData}
              submittedAccordions={submittedAccordions}
              setSubmittedAccordions={setSubmittedAccordions}
              isEnabled={isAccordionEnabled(2)}
              setAgentData={setAgentData}
              agentData={agentData}
              selectedDescription={selectedDescription}
              buyingForSelf={buyingForSelf}
              primaryBuyerData={primaryBuyerData}
              cobuyerData={cobuyerData}
            />
          )}
          {/* //!THIS IS THE FOURTH ACCORDIAN */}
          <EditClosingAgentAndTitleInsuranceProvider
            collapseAccordian={collapseAccordian}
            setCollapseAccordian={setCollapseAccordian}
            cifData={cifData}
            submittedAccordions={submittedAccordions}
            setSubmittedAccordions={setSubmittedAccordions}
            isEnabled={isAccordionEnabled(4)}
            setClosingAgentForm={setClosingAgentForm}
            closingAgentForm={closingAgentForm}
            setTitleInsuranceForm={setTitleInsuranceForm}
            titleInsuranceForm={titleInsuranceForm}
            selectedClosingOption={selectedClosingOption}
            setSelectedClosingOption={setSelectedClosingOption}
          />
          {/* //!THIS IS THE FIFTH ACCORDIAN */}
          {pof === "Optional" || pof === "Required" ? (
            <EditProofOfFunds
              cifId={editCifUserData.cifId}
              cifData={cifData}
              submittedAccordions={submittedAccordions}
              setCollapseAccordian={setCollapseAccordian}
              setSubmittedAccordions={setSubmittedAccordions}
              collapseAccordian={collapseAccordian}
              isEnabled={isAccordionEnabled(5)}
              listingId={listingId}
              pof={pof}
              primaryBuyerData={primaryBuyerData}
              cobuyerData={cobuyerData}
              agentData={agentData}
              selectedDescription={selectedDescription}
              buyingForSelf={buyingForSelf}
              hasCobuyer={hasCobuyer}
              primaryEntityType={primaryEntityType}
              cobuyerEntityType={cobuyerEntityType}
              uploadedFiles={uploadedFiles}
              setUploadedFiles={setUploadedFiles} // Add this prop
              formState={formState}
              isSubmitting={isSubmitting}
              setIsSubmitting={setIsSubmitting}
              commercialPof={commercialPof}
              setCifCompleted={setCifCompleted}
              closingAgentForm={closingAgentForm}
              titleInsuranceForm={titleInsuranceForm}
              selectedClosingOption={selectedClosingOption}
              paymentFlag={paymentFlag}
              setIsBidDeposit={setIsBidDeposit}
              winningBidUserEmail={winningBidUserEmail}
            />
          ) : (
            <EditSubmit
              cifId={editCifUserData.cifId}
              cifData={cifData}
              hasCobuyer={hasCobuyer}
              setHasCobuyer={setHasCobuyer}
              cifFormDetails={cifFormDetails}
              submittedAccordions={submittedAccordions}
              setCollapseAccordian={setCollapseAccordian}
              setSubmittedAccordions={setSubmittedAccordions}
              collapseAccordian={collapseAccordian}
              isEnabled={isAccordionEnabled(5)}
              setCifCompleted={setCifCompleted}
              isSubmitting={isSubmitting}
              setIsSubmitting={setIsSubmitting}
              formState={formState}
              primaryBuyerData={primaryBuyerData}
              agentData={agentData}
              cobuyerData={cobuyerData}
              selectedDescription={selectedDescription}
              buyingForSelf={buyingForSelf}
              primaryEntityType={primaryEntityType}
              cobuyerEntityType={cobuyerEntityType}
              uploadedFiles={uploadedFiles}
              setUploadedFiles={setUploadedFiles}
              commercialPof={commercialPof}
              listingId={listingId}
              closingAgentForm={closingAgentForm}
              titleInsuranceForm={titleInsuranceForm}
              selectedClosingOption={selectedClosingOption}
              paymentFlag={paymentFlag}
              setIsBidDeposit={setIsBidDeposit}
              winningBidUserEmail={winningBidUserEmail}
            />
          )}
        </div>
      </div>
    </div>
  );
};

export default EditCifDetails;
